import { EventLog } from '@adornis/analytics/db/eventlog.js';
import { Entity } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * @entity ChancenEventlog
 */
@Entity()
export class ChancenEventlog extends EventLog {
  public static override _class = 'ChancenEventlog';

  constructor(doc: PartialEntityData<ChancenEventlog>) {
    // Elias f*cked routing
    doc.route = 'dummyroute';
    super(doc);
  }
}
